<template>
  <div class="main-view">
    <Tabs></Tabs>
  </div>
</template>

<script setup lang="ts">
import Tabs from '@/components/services/Tabs.vue'
</script>

<style scoped>
.main-view {
  height: 100%;
}
</style>
